import ProjectOwner from './ProjectOwner'

export default ProjectOwner


// WEBPACK FOOTER //
// ./resources/assets/js/components/ProjectOwner/index.js